export default __webpack_public_path__ + "static/media/Group 5633.d6ab49c4.svg";